import React, { Component } from 'react'
import { connect } from 'react-redux'
import { TokenActions, SnackbarActions } from 'actionsets'
import StyleSheet, { AppStyles } from 'styles'
import { Link } from 'react-router-dom'
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import { CenteredCard } from 'components'
import TextField from '@material-ui/core/TextField'
import Checkbox from 'components/styled/Checkbox'
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Button from '@material-ui/core/Button'
import Typography from '@material-ui/core/Typography'
import {eventKeyMatches, KEYS} from 'utils'

export class SignIn extends Component{

  constructor(props){
    super(props)
    TokenActions.bindActions(this)
    SnackbarActions.bindActions(this, 'snackbar')
    this.state = {}
  }

  componentDidMount(){
    this.actions.clearErrors()
  }

  setEmail = ({target: { value: email}}) => {
    this.setState({email})
  }

  setPassword = ({target: { value: password}}) => {
    this.setState({password})
  }

  setOtpAttempt = ({target: { value: otpAttempt}}) => {
    this.setState({otpAttempt})
  }

  setRememberMe =  ({target: {checked: rememberMe} }) => {
    this.setState({rememberMe})
  }

  is2faRequiredError = error => {
    return error && error.code === "ERR_MFA_NOT_AUTHENTICATED" && error.title === "2FA Required"
  }

  signIn = async (provider = null, credentials = null) => {
    try{
      switch (provider) {
        case 'LinkedIn':
          let { rememberMe } = this.state
          let params = { ...credentials, rememberMe}
          await this.actions.createLinkedin(params)
          break
        default:
          await this.actions.create(this.state)
          break
      }

      const location = (this.props.savedLocation && !this.props.savedLocation.match(/^\/?tokens\//)) ?
        this.props.savedLocation :
        '/'
      this.props.history.push(location)
      this.actions.snackbar.success('Signed in succesfully')
    }catch(err){
      if (!this.is2faRequiredError(err))
        this.actions.snackbar.error('Sign in failed')
    }
  }

  linkedInAuthorized = (credentials) => {
    return this.signIn('LinkedIn', credentials)
  }

  renderError = () =>
    <Typography className={styles.error} variant='body2'>
      {!this.is2faRequiredError(this.props.error) && this.props.error.title}
    </Typography>


  render = () =>
    <CenteredCard className={styles.card}>
      <CardContent className={styles.content} onKeyUp={(e) => eventKeyMatches(e, KEYS.enter) && this.signIn()}>
        <Typography variant='h6' style={{marginBottom: 10}}>Sign in</Typography>
        {this.props.error && <div className={styles.error}>{this.renderError()}</div>}
        <div className={styles.sliderView}>
          <div className={styles.slider} style={(this.props.error && this.props.error.code === "ERR_MFA_NOT_AUTHENTICATED") ? {left: '-100%'} : {}}>
            <div className={styles.slide}>
              <TextField
                label='Email address'
                type='email'
                onChange={this.setEmail}
                fullWidth
                margin="normal"
              />
              <TextField
                label='Password'
                type='password'
                onChange={this.setPassword}
                fullWidth
                margin="normal"
              />
            </div>
            <div className={styles.slide}>
              <TextField
                label='2FA Code'
                type='text'
                onChange={this.setOtpAttempt}
                fullWidth
                margin="normal"
              />
            </div>
          </div>
        </div>
        <Link className={[AppStyles.link, styles.forgot].join(' ')} to='/tokens/forgot'>Forgot password?</Link>
        <FormControlLabel className={styles.checkbox} label='Remember Me' control={<Checkbox checked={this.state.rememberMe} onChange={this.setRememberMe}/>}/>
      </CardContent>
      <CardActions className={styles.actions}>
        <Button fullWidth variant='contained' color="primary" onClick={this.signIn}>Sign in</Button>
        <Link className={[AppStyles.link, styles.navBeneath].join(' ')} to='/tokens/sign_up'>I don't have an account, SIGN UP</Link>
      </CardActions>
    </CenteredCard>
}

const styles = StyleSheet({
  error: {
    color: '#EA5142'
  },
  checkbox: {
    flex: 1,
    marginLeft: -14,
    '& > span':{
      fontSize: 11
    }
  },
  button:{
    float: 'right',
    display: 'block',
    maxWidth: 200,
    margin: 0,
    paddingLeft: 30,
    paddingRight: 30,
  },
  linkedIn: {
    marginTop: 30
  },
  card: {
    padding: 15,
    paddingBottom: 50,
  },
  actions: {
    flexWrap: 'wrap',
    paddingLeft: 16,
    paddingRight: 16,
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
  },
  forgot: {
    textDecoration: 'none',
    margin: '5px 0',
    flex: '0 auto',
    minWidth: 250,
    fontSize: 11,
    textAlign: 'right'
  },
  navBeneath: {
    color: '#b9b39b',
    fontSize: 14,
    marginTop: 15,
    textAlign: 'center',
    width: '100%'
  },
  sliderView: {
    width: '100%',
    overflow: 'hidden'
  },
  slider: {
    left: 0,
    position: 'relative',
    width: '200%',
    display: 'flex',
    transition: 'left 500ms'
  },
  slide: {
    flex: 1,
  }
})

export default connect(({tokens}) => tokens)(SignIn)